import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {KeypadControlsView} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsView';
import {KeypadControlsViewMobile} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsViewMobile';
import {KeypadControlsModule} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsModule';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {AutoplayEvents} from '@gongxigames/framework/slot/modules/autoplay';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

export class KeypadControlsMainGameState extends ModuleState<KeypadControlsView | KeypadControlsViewMobile, KeypadControlsModule, GlobalEventsMapForBackwardCompatibility> {

    public onEnterState(): void {
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.RESPIN_ON_FREESPINS_RESTORED, this.onFreeSpinsRestored.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(AutoplayEvents.START_AUTOPLAY, this.onAutoplayStarted.bind(this));
        this.setEventHandler(FlowModuleEvents.FREESPINS_RESTORED, this.onFreeSpinsRestored.bind(this));
        this.setEventHandler(GenericPopupEvents.INTRO_STARTED, this.onPopupStarted.bind(this));
    }

    protected onPopupStarted(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_INTRO) {
            this.onFreeSpinsIntro();
        }
    }

    protected onFreeSpinsIntro(): void {
        this.module.gotoState(KeypadControlsModule.FREESPINS_STATE);
    }

    protected onFreeSpinsRestored(): void {
        this.module.gotoState(KeypadControlsModule.FREESPINS_STATE);
    }

    protected onReelsSpinningStarted(): void {
        this.module.disableAll(UIDisableReason.SPINNING);
    }

    protected isBigWin(): boolean {
        return this.module.logic.getWin() >= this.module.logic.getBigWinLimit();
    }

    protected onAutoplayStarted(): void {
        this.module.gotoState(KeypadControlsModule.AUTOPLAY_STATE);
    }
}
